<template>
  <v-card :loading="loadingCard">
    <v-card-title>
      <v-row justify="space-between">
        <span class="font-weight-light" style="font-size: 16pt">{{ $t('label.sendComments') }}</span>
        <v-btn icon @click.stop="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-row>
    </v-card-title>
    <v-form v-model="isFormValid" ref="commentsForm">
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="releaseComments.comments"
              rows="3"
              outlined
              no-resize
              :rules="[rules.required, rules.minCharacters(releaseComments.comments, 20)]"
              dense>
            </v-textarea>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn small depressed :disabled="loadingCard" @click.stop="close">{{ $t('label.close') }}</v-btn>
        <v-btn small depressed color="primary" :disabled="loadingCard || !isFormValid" @click.stop="sendMail">{{ $t('label.send') }}</v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import { loading, rules, showMessage } from '../../../mixins'
export default {
  name: 'ReleaseComment',
  props: {
    releaseId: Number
  },
  mixins: [loading, showMessage, rules],
  data: () => ({
    loadingCard: false,
    isFormValid: null,
    releaseComments: {
      comments: ''
    }
  }),
  methods: {
    sendMail () {
      this.loadingCard = true
      this.$proxy.post(`api/edi/releases/${this.releaseId}/comments`, this.releaseComments)
        .then((r) => {
          this.showMessage(this.$t('message.success.commentsSend'))
          this.clearForm()
          this.$emit('close')
        })
        .catch((e) => {
          this.showHttpErrorMessage(e)
        })
        .finally(() => {
          this.loadingCard = false
        })
    },
    clearForm () {
      this.releaseComments = {
        comments: ''
      }
      this.$refs.commentsForm.resetValidation()
    },
    close () {
      this.clearForm()
      this.$emit('close')
    }
  }
}
</script>

<style>

</style>
